import localStorageFallback from "local-storage-fallback";

var storage;

const TEST_KEY = "__test";

try {
  storage = window.sessionStorage;
  storage.setItem(TEST_KEY, "1");
  storage.removeItem(TEST_KEY);
  // OK
} catch (e) {
  console.warn("Session storage not available: " + e);
  console.warn("Fallback to local-storage-with-fallback");
  storage = localStorageFallback.storage;
}

// getItem :: String -> Effect (Nullable String)
export function getItem(key) {
  return function () {
    return storage.getItem(key);
  };
}

// setItem :: String -> String -> Effect Unit
export function setItem(key) {
  return function (value) {
    return function () {
      storage.setItem(key, value);
    };
  };
}
